module.exports = {
      id: "icon-smilies2-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-smilies2",
      toString: function () {
        return this.url;
      }
    }